module.exports = __webpack_public_path__ + "static/media/logo.ee7f7299.svg";